<section class="cmn-innerpage-wrapper" *ngIf="!contentLoading">
  <div class="head">
    <h1>{{ faqId ? "Edit FAQ" : "New Faq" }}</h1>
  </div>

  <div class="scroll-wrapper">
    <form id="translation" [formGroup]="mainForm" class="translationForm">

      <!-- Language -->
      <div class="full-width-Wrapper">
        <div class="lang-wrapper">
          <mat-form-field>
            <mat-select formControlName="langId" placeholder="Language">
              <mat-option *ngFor="let lang of languages" [value]="lang.id" [disabled]="isLangUsed(lang.id)">
                {{ lang.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="mainForm.get('langId')?.hasError('required')">
              Language is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Question -->
      <label class="block-pointer">
        <span>Question</span>
        <mat-form-field>
          <textarea matInput placeholder="Question" formControlName="question"></textarea>
          <mat-error *ngIf="mainForm.get('question')?.hasError('required')">Question is required</mat-error>
          <mat-error *ngIf="mainForm.get('question')?.hasError('onlySpaces')">Question cannot be empty</mat-error>
          <mat-error *ngIf="mainForm.get('question')?.hasError('onlySpecialAlphaChars')">
            Question cannot contain only special characters and numbers
          </mat-error>
        </mat-form-field>
      </label>

      <!-- Answer -->
      <label class="block-pointer">
        <span>Answer</span>
        <mat-form-field>
          <textarea matInput placeholder="Answer" formControlName="answer"></textarea>
          <mat-error *ngIf="mainForm.get('answer')?.hasError('required')">Answer is required</mat-error>
          <mat-error *ngIf="mainForm.get('answer')?.hasError('onlySpaces')">Answer cannot be empty</mat-error>
          <mat-error *ngIf="mainForm.get('answer')?.hasError('onlySpecialChars')">
            Answer cannot contain only special characters
          </mat-error>
        </mat-form-field>
      </label>

      <!-- Add Translation -->
      <div class="full-width-Wrapper add-button-div">
        <p [style.visibility]="faqTranslations.length === 0 ? 'visible' : 'hidden'">
          Add at least one translation to save
        </p>

        <button type="button" class="add-button unblock-pointer" *ngIf="faqTranslations.length !== languages.length"
          (click)="addFaqTranslation()">
          Add
        </button>
      </div>

      <!-- VIDEO SECTION -->
      <div class="grid-wrapper">
        <div class="audio-video-wrapper">

          <!-- Toggle -->
          <div class="audioActionWrapper">
            <label class="selector-option">
              <input type="checkbox" [checked]="videoSource === 'upload'"
                (click)="$event.preventDefault(); setVideoSource('upload')" />
              <h6 [class.active]="videoSource === 'upload'">Upload Video</h6>
            </label>

            <label class="selector-option">
              <input type="checkbox" [checked]="videoSource === 'url'"
                (click)="$event.preventDefault(); setVideoSource('url')" />
              <h6 [class.active]="videoSource === 'url'">Video URL</h6>
            </label>
          </div>

          <!-- Upload UI -->
          <div class="upload-box" *ngIf="videoSource === 'upload'">
            <label class="upload-btn" [class.hidden]="videoUploading">
              Choose A File
              <input type="file" accept=".mp4,.mov" (change)="onVideoUpload($event)" [disabled]="videoUploading" />
            </label>

            <div class="upload-overlay" *ngIf="videoUploading">
              <span class="spinner"></span>
              <p>Uploading file, please wait...</p>
            </div>
            <ng-container *ngIf="videoFileName">
              <strong>{{ videoFileName }}</strong>
            </ng-container>
            <ng-container *ngIf="!videoFileName && mainForm.get('videoUrl')?.value">
              <strong class="url-text">
                {{ mainForm.get('videoUrl')?.value }}
              </strong>
            </ng-container>
            <ng-container *ngIf="!videoFileName && !mainForm.get('videoUrl')?.value">
              Video should be in MP4 or MOV format and not exceed 300MB in size.
            </ng-container>
          </div>

          <!-- Video URL UI -->
          <div class="url-box" *ngIf="videoSource === 'url'">
            <mat-form-field class="full-width">
              <input matInput placeholder="Paste video URL" formControlName="videoUrl" />
              <mat-error *ngIf="mainForm.get('videoUrl')?.hasError('required')">
                Video URL is required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Hint / Preview -->
          <p class="upload-hint" *ngIf="!videoUploading">


          </p>

        </div>
      </div>

    </form>
  </div>

  <!-- FAQ LIST -->
  <div class="faq-wrapper">
    <cdk-accordion class="faq-accordion">
      @for (faq of faqTranslations; track faq; let idx = $index) {
      <cdk-accordion-item #accordionItem="cdkAccordionItem" class="faq-item">
        <button class="faq-question" (click)="accordionItem.toggle()">
          <h6>{{ faq.question }}</h6>
        </button>
        @if (accordionItem.expanded) {
        <div class="faq-answer">{{ faq.answer }}</div>
        }
      </cdk-accordion-item>
      }
    </cdk-accordion>
  </div>

  <!-- Buttons -->
  <div class="btnWrapper">
    <button (click)="onCancel()" class="cmn-cancel-btn">Cancel</button>
    <button class="cmn-next-btn" [disabled]="!faqTranslations.length || isSubmitting" (click)="onSaveFaq()">
      {{ faqId ? "Update" : "Save" }}
    </button>
  </div>
</section>

<app-content-loader [visible]="contentLoading"></app-content-loader>
